export interface UploadFile {
  saved: boolean;
  isValid?: boolean;
  state: string;
  hasGlitches?: boolean;
  isBlurry?: boolean;
}
